module.exports = __webpack_public_path__ + "media/images/features/support/heading-type-line-0aad26549ba1bfa58b5cea3741e884bf.svg";